import { PropsWithChildren } from "react";

export function CardSection(props: PropsWithChildren<{
    label: string,
    className?: string,
    value?: string | number | undefined,
    subLabel?: string,
    persentase?: number | undefined,
    icon?: JSX.Element
}>) {

    return (
        <div className={`${props.className}`}>
            <div>
                <div className="text-md text-slate-600 font-bold flex items-center gap-2">
                    <div>
                        {props.label}
                    </div>
                    {props.icon &&
                        <div className="text-[18px]">
                            {props.icon}
                        </div>}
                </div>
                <div className="text-2xl font-bold">{props.value}</div>
                <div className="my-3">
                    <span>{props.subLabel}</span>
                </div>
            </div>
            {props.children}
        </div>
    )
}